import {
  z
} from 'zod';
import { zPassword, zPhoneNumber, ageCheck } from '@shared/lib';


const IS_SIXTEEN = ageCheck(16);

type DefaultValues = {
  [field: string]: string | number | Date;
};


export const createZodSchema = (defaultValues: DefaultValues) => {
  return Object.entries(defaultValues).reduce((schema, [key, val]) => {
    let valSchema;

    switch (true) {
      case typeof val === 'string' && key === 'email':
        valSchema = z.string().email();
        break;
      case typeof val === 'string' && key === 'password':
        valSchema = zPassword;
        break;
      case typeof val === 'string' && (key === 'title' || key === 'instructor' || key === 'type'):
        valSchema = z.string().trim().min(1);
        break;
      case typeof val === 'string' && (key === 'date_of_birth'):
        valSchema = IS_SIXTEEN;
        break;
      case typeof val === 'string' && (key === 'start' || key === 'end'):
        valSchema = z.string().min(4);
        break;
      case typeof val === 'string' && (key === 'phone_number'):
        valSchema = zPhoneNumber;
        break;
      //Come back and implement a way to check decimals
      case typeof val === 'string' && (key === 'pt_rate' || key === 'group_rate'):
        valSchema = z.string().max(5);
        break;
      case typeof val === 'string':
        valSchema = z.string();
        break;
      case typeof val === 'number':
        valSchema = z.number();
        break;
      default:
        valSchema = z.unknown();
        break;
    }
    return schema.extend({
      [key]: valSchema,
    });
  }, z.object({}));
};

/*

FOR USAGE WITH CREATEDEFAULTVALS

DefaultValues is an Object where each key represents the inputName

initially:
ex: {
  email: '',
  password: ''
}

When we call Object.entires on defaultValues to iterate over our defaultValues and then we call reduce
passing in schema, and [key, val] to our reduce callback

Within our callback we are checking the typeof our currentValues and what our key is to inorder to return a schema for that field

Figure out where to add this. This might have to be implemented later for Validating between fields
.refine((schema) => {
      const { classStart, classEnd } = schema;
      if (typeof classStart === 'string' && typeof classEnd === 'string') {
        return !(
          classStart[2] < classEnd[2] && classStart[0] <= classEnd[0]
        );
      }
    }, 'Start Time cannot be less than End Time');

*/
